"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDGs = void 0;
exports.SDGs = [
    {
        description: 'End poverty in all its forms everywhere',
        goalNumber: 1,
        title: 'No Poverty',
    },
    {
        description: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
        goalNumber: 2,
        title: 'Zero Hunger',
    },
    {
        description: 'Ensure healthy lives and promote well-being for all at all ages',
        goalNumber: 3,
        title: 'Good Health and Well-being',
    },
    {
        description: 'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all',
        goalNumber: 4,
        title: 'Quality Education',
    },
    {
        description: 'Achieve gender equality and empower all women and girls',
        goalNumber: 5,
        title: 'Gender Equality',
    },
    {
        description: 'Ensure availability and sustainable management of water and sanitation for all',
        goalNumber: 6,
        title: 'Clean Water and Sanitation',
    },
    {
        description: 'Ensure access to affordable, reliable, sustainable and modern energy for all',
        goalNumber: 7,
        title: 'Affordable and Clean Energy',
    },
    {
        description: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
        goalNumber: 8,
        title: 'Decent Work and Economic Growth',
    },
    {
        description: 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
        goalNumber: 9,
        title: 'Industry, Innovation and Infrastructure',
    },
    {
        description: 'Reduce inequality within and among countries',
        goalNumber: 10,
        title: 'Reduced Inequality',
    },
    {
        description: 'Make cities and human settlements inclusive, safe, resilient and sustainable',
        goalNumber: 11,
        title: 'Sustainable Cities and Communities',
    },
    {
        description: 'Ensure sustainable consumption and production patterns',
        goalNumber: 12,
        title: 'Responsible Consumption and Production',
    },
    {
        description: 'Take urgent action to combat climate change and its impacts*',
        goalNumber: 13,
        title: 'Climate Action',
    },
    {
        description: 'Conserve and sustainably use the oceans, seas and marine resources for sustainable development',
        goalNumber: 14,
        title: 'Life Below Water',
    },
    {
        description: 'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss',
        goalNumber: 15,
        title: 'Life on Land',
    },
    {
        description: 'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels',
        goalNumber: 16,
        title: 'Peace and Justice Strong Institutions',
    },
    {
        description: 'Strengthen the means of implementation and revitalize the global partnership for sustainable development',
        goalNumber: 17,
        title: 'Partnerships to achieve the Goal',
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VzdGFpbmFibGUtZGV2ZWxvcG1lbnQtZ29hbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL3N1c3RhaW5hYmxlLWRldmVsb3BtZW50LWdvYWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQXlCYSxRQUFBLElBQUksR0FBbUI7SUFDbEM7UUFDRSxXQUFXLEVBQUUseUNBQXlDO1FBQ3RELFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLFlBQVk7S0FDcEI7SUFDRDtRQUNFLFdBQVcsRUFDVCw4RkFBOEY7UUFDaEcsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsYUFBYTtLQUNyQjtJQUNEO1FBQ0UsV0FBVyxFQUNULGlFQUFpRTtRQUNuRSxVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSw0QkFBNEI7S0FDcEM7SUFDRDtRQUNFLFdBQVcsRUFDVCxzR0FBc0c7UUFDeEcsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsbUJBQW1CO0tBQzNCO0lBQ0Q7UUFDRSxXQUFXLEVBQUUseURBQXlEO1FBQ3RFLFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLGlCQUFpQjtLQUN6QjtJQUNEO1FBQ0UsV0FBVyxFQUNULGdGQUFnRjtRQUNsRixVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSw0QkFBNEI7S0FDcEM7SUFDRDtRQUNFLFdBQVcsRUFDVCw4RUFBOEU7UUFDaEYsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsNkJBQTZCO0tBQ3JDO0lBQ0Q7UUFDRSxXQUFXLEVBQ1Qsc0hBQXNIO1FBQ3hILFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLGlDQUFpQztLQUN6QztJQUNEO1FBQ0UsV0FBVyxFQUNULDJHQUEyRztRQUM3RyxVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSx5Q0FBeUM7S0FDakQ7SUFDRDtRQUNFLFdBQVcsRUFBRSw4Q0FBOEM7UUFDM0QsVUFBVSxFQUFFLEVBQUU7UUFDZCxLQUFLLEVBQUUsb0JBQW9CO0tBQzVCO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsOEVBQThFO1FBQ2hGLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLG9DQUFvQztLQUM1QztJQUNEO1FBQ0UsV0FBVyxFQUFFLHdEQUF3RDtRQUNyRSxVQUFVLEVBQUUsRUFBRTtRQUNkLEtBQUssRUFBRSx3Q0FBd0M7S0FDaEQ7SUFDRDtRQUNFLFdBQVcsRUFBRSw4REFBOEQ7UUFDM0UsVUFBVSxFQUFFLEVBQUU7UUFDZCxLQUFLLEVBQUUsZ0JBQWdCO0tBQ3hCO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsZ0dBQWdHO1FBQ2xHLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNEO1FBQ0UsV0FBVyxFQUNULDhMQUE4TDtRQUNoTSxVQUFVLEVBQUUsRUFBRTtRQUNkLEtBQUssRUFBRSxjQUFjO0tBQ3RCO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsbUxBQW1MO1FBQ3JMLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLHVDQUF1QztLQUMvQztJQUNEO1FBQ0UsV0FBVyxFQUNULDBHQUEwRztRQUM1RyxVQUFVLEVBQUUsRUFBRTtRQUNkLEtBQUssRUFBRSxrQ0FBa0M7S0FDMUM7Q0FDTyxDQUFDIn0=